import { render, staticRenderFns } from "./SchoolsApp.vue?vue&type=template&id=85049f38&scoped=true"
import script from "./SchoolsApp.vue?vue&type=script&lang=js"
export * from "./SchoolsApp.vue?vue&type=script&lang=js"
import style0 from "./SchoolsApp.vue?vue&type=style&index=0&id=85049f38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85049f38",
  null
  
)

export default component.exports